import { isRecord } from '../core/utils/is-record';
import { dateOrNull, idString } from '../core/utils/wire-value-utils';

/**
 * Base for Hub entity models: `id` plus the standard timestamps as `Date`s.
 *
 * Copies named fields only (never spreads or assigns the input), so unknown keys and `__proto__` in API
 * data cannot leak onto the instance. Invalid or missing dates become `null`.
 *
 * Subclasses must NOT redeclare `id`, `createdAt`, `updatedAt` or `deletedAt`: with ES2022 class fields,
 * a redeclared field is re-initialised to `undefined` after this constructor runs.
 */
export abstract class Base {
  id: string;
  createdAt: Date | null;
  updatedAt: Date | null;
  deletedAt: Date | null;

  constructor(data: unknown) {
    const source = isRecord(data) ? data : {};
    this.id = idString(source['id']);
    this.createdAt = dateOrNull(source['createdAt']);
    this.updatedAt = dateOrNull(source['updatedAt']);
    this.deletedAt = dateOrNull(source['deletedAt']);
  }
}

